import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { reducer as oidc, loadUser } from 'redux-oidc';
import { createLogger } from 'redux-logger';

import manager from '../oidc';
import mobileCheck from '../mobile';

import { reducer as topbar } from '@angellira/top-app-bar';
import user from './user';
import mobile from './mobile';

const reducers = {
  oidc,
  user,
  mobile,
  topbar
};

const structure = Object
  .keys(reducers)
  .reduce((s, x) => (s[x] = undefined) || s, {});

const middlewares = [];
const reducer = combineReducers(reducers);

middlewares.push(thunk);

if (process.env.NODE_ENV === 'development') {
  middlewares.push(createLogger({ collapsed: true }));
}

const store = createStore(
  reducer,
  structure,
  applyMiddleware(...middlewares)
);

loadUser(store, manager);
mobileCheck(store);

export default store;
